import React, {useEffect, useRef} from "react";

import styles from "./Graph.module.scss";
import {isInViewport} from "../../Functions";

import gsap from "gsap";

export default function TimeRemote () {
    const element = useRef(null);

    useEffect(() => {

        const bars = element.current.querySelectorAll('.bar-wrapper rect:not(:first-child)');
        const numbers = element.current.querySelectorAll('.bar-wrapper .graph-numbers text');

        gsap.set(bars, {
            attr: {
                transform: 'scale(1,0)'
            }
        });

        gsap.set(numbers, {
            opacity: 0
        });

        if (element.current && !element.current.classList.contains('animated')) {
            window.addEventListener('scroll', () => {
                if (isInViewport(element.current)) {

                    Object.values(bars).map((bar, index) =>
                        gsap.to(bar, .7, {
                            transform: 'scale(1,1)',
                            delay: .1 * index,
                            onComplete: () => {
                                gsap.to(numbers[index], .3, {
                                    opacity: 1
                                })
                            }
                        })
                    );

                    element.current.classList.add('animated');
                }
            })
        }
    }, []);

    const svg = `
<svg width="921px" height="471px" viewBox="0 0 921 471" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <g transform="translate(-1.000000, -4.000000)">
            <text font-family="OpenSans-Regular, Open Sans" font-size="16" font-weight="normal" line-spacing="26" fill="#000000">
                <tspan x="249.902344" y="469">É</tspan>
                <tspan x="258.800781" y="469">conomies avancées </tspan>
            </text>
            <text font-family="OpenSans-Regular, Open Sans" font-size="16" font-weight="normal" line-spacing="26" fill="#000000">
                <tspan x="719.214844" y="469">É</tspan>
                <tspan x="728.113281" y="469">conomies émergents </tspan>
            </text>
            <g transform="translate(0.000000, 36.000000)">
                <path d="M15.5,218 L15.5,400" stroke="#DFD7BD" stroke-linecap="square"></path>
                <text font-family="OpenSans-Semibold, Open Sans" font-size="13" font-weight="500" fill="#000000">
                    <tspan x="0.0183105469" y="204">100</tspan>
                    <tspan x="22.279541" y="204" font-family="OpenSans-Regular, Open Sans" font-weight="normal">%</tspan>
                </text>
                <path d="M15.5,0.5 L15.5,182.5" stroke="#DFD7BD" stroke-linecap="square"></path>
            </g>
            <g class="bar-wrapper" transform="translate(59.000000, 0.000000)">
                <g transform="translate(13.000000, 36.000000)">
                    <rect fill="#EEE8D3" x="0" y="0" width="60" height="400"></rect>
                    <rect fill="#7FC82F" x="0" y="216" width="60" height="184" style="transform-origin: 100% 100%; transform-box: fill-box;"></rect>
                    <rect fill="#417505" x="0" y="267" width="60" height="133" style="transform-origin: 100% 100%; transform-box: fill-box;"></rect>
                </g>
                <text font-family="OpenSans-Semibold, Open Sans" font-size="13" font-weight="500" fill="#000000">
                    <tspan x="0.680175781" y="14">Royaume-Uni</tspan>
                </text>
                
                <g class="graph-numbers">
                    <text font-family="OpenSans-Semibold, Open Sans" font-size="13" font-weight="500" fill="#FFFFFF">
                        <tspan x="30.2285156" y="270">46</tspan>
                        <tspan x="45.0693359" y="270" font-family="OpenSans-Regular, Open Sans" font-weight="normal">%</tspan>
                    </text>
                    <text font-family="OpenSans-Semibold, Open Sans" font-size="13" font-weight="500" fill="#FFFFFF">
                        <tspan x="30.2285156" y="321">33</tspan>
                        <tspan x="45.0693359" y="321" font-family="OpenSans-Regular, Open Sans" font-weight="normal">%</tspan>
                    </text>
                </g>
            </g>
            <g class="bar-wrapper" transform="translate(158.000000, 0.000000)">
                <g transform="translate(4.000000, 36.000000)">
                    <rect fill="#EEE8D3" x="0" y="0" width="60" height="400"></rect>
                    <rect fill="#7FC82F" x="0" y="243" width="60" height="157" style="transform-origin: 100% 100%; transform-box: fill-box;"></rect>
                    <rect fill="#417505" x="0" y="280" width="60" height="120" style="transform-origin: 100% 100%; transform-box: fill-box;"></rect>
                </g>
                <text font-family="OpenSans-Semibold, Open Sans" font-size="13" font-weight="500" fill="#000000">
                    <tspan x="0.862060547" y="14">Allemagne</tspan>
                </text>
                                <g class="graph-numbers">

                <text font-family="OpenSans-Semibold, Open Sans" font-size="13" font-weight="500" fill="#FFFFFF">
                    <tspan x="21.2285156" y="297">39</tspan>
                    <tspan x="36.0693359" y="297" font-family="OpenSans-Regular, Open Sans" font-weight="normal">%</tspan>
                </text>
                <text font-family="OpenSans-Semibold, Open Sans" font-size="13" font-weight="500" fill="#FFFFFF">
                    <tspan x="21.2285156" y="334">30</tspan>
                    <tspan x="36.0693359" y="334" font-family="OpenSans-Regular, Open Sans" font-weight="normal">%</tspan>
                </text>
                </g>
            </g>
            <g class="bar-wrapper" transform="translate(250.000000, 0.000000)">
                <g transform="translate(2.000000, 36.000000)">
                    <rect fill="#EEE8D3" x="0" y="0" width="60" height="400"></rect>
                    <rect fill="#7FC82F" x="0" y="243" width="60" height="157" style="transform-origin: 100% 100%; transform-box: fill-box;"></rect>
                    <rect fill="#417505" x="0" y="283" width="60" height="117" style="transform-origin: 100% 100%; transform-box: fill-box;"></rect>
                </g>
                <text font-family="OpenSans-Semibold, Open Sans" font-size="13" font-weight="500" fill="#000000">
                    <tspan x="0.309326172" y="14">Etats-Unis</tspan>
                </text>
                                <g class="graph-numbers">

                <text font-family="OpenSans-Semibold, Open Sans" font-size="13" font-weight="500" fill="#FFFFFF">
                    <tspan x="19.2285156" y="297">39</tspan>
                    <tspan x="34.0693359" y="297" font-family="OpenSans-Regular, Open Sans" font-weight="normal">%</tspan>
                </text>
                <text font-family="OpenSans-Semibold, Open Sans" font-size="13" font-weight="500" fill="#FFFFFF">
                    <tspan x="19.2285156" y="337">29</tspan>
                    <tspan x="34.0693359" y="337" font-family="OpenSans-Regular, Open Sans" font-weight="normal">%</tspan>
                </text>
                </g>
            </g>
            <g class="bar-wrapper" transform="translate(342.000000, 0.000000)">
                <g transform="translate(0.000000, 36.000000)">
                    <rect fill="#EEE8D3" x="0" y="0" width="60" height="400"></rect>
                    <rect fill="#7FC82F" x="0" y="244" width="60" height="156" style="transform-origin: 100% 100%; transform-box: fill-box;"></rect>
                    <rect fill="#417505" x="0" y="283" width="60" height="117" style="transform-origin: 100% 100%; transform-box: fill-box;"></rect>
                </g>
                <text font-family="OpenSans-Semibold, Open Sans" font-size="13" font-weight="500" fill="#000000">
                    <tspan x="12.1408691" y="14">Japon</tspan>
                </text>
                                <g class="graph-numbers">

                <text font-family="OpenSans-Semibold, Open Sans" font-size="13" font-weight="500" fill="#FFFFFF">
                    <tspan x="17.2285156" y="298">39</tspan>
                    <tspan x="32.0693359" y="298" font-family="OpenSans-Regular, Open Sans" font-weight="normal">%</tspan>
                </text>
                <text font-family="OpenSans-Semibold, Open Sans" font-size="13" font-weight="500" fill="#FFFFFF">
                    <tspan x="17.2285156" y="337">29</tspan>
                    <tspan x="32.0693359" y="337" font-family="OpenSans-Regular, Open Sans" font-weight="normal">%</tspan>
                </text>
                </g>
            </g>
            <g class="bar-wrapper" transform="translate(432.000000, 0.000000)">
                <g transform="translate(0.000000, 36.000000)">
                    <rect fill="#EEE8D3" x="0" y="0" width="60" height="400"></rect>
                    <rect fill="#7FC82F" x="0" y="243" width="60" height="157" style="transform-origin: 100% 100%; transform-box: fill-box;"></rect>
                    <rect fill="#417505" x="0" y="288" width="60" height="112" style="transform-origin: 100% 100%; transform-box: fill-box;"></rect>
                </g>
                <text font-family="OpenSans-Semibold, Open Sans" font-size="13" font-weight="500" fill="#000000">
                    <tspan x="8.87817383" y="14">France</tspan>
                </text>
                                <g class="graph-numbers">

                <text font-family="OpenSans-Semibold, Open Sans" font-size="13" font-weight="500" fill="#FFFFFF">
                    <tspan x="17.2285156" y="297">39</tspan>
                    <tspan x="32.0693359" y="297" font-family="OpenSans-Regular, Open Sans" font-weight="normal">%</tspan>
                </text>
                <text font-family="OpenSans-Semibold, Open Sans" font-size="13" font-weight="500" fill="#FFFFFF">
                    <tspan x="17.2285156" y="343">28</tspan>
                    <tspan x="32.0693359" y="343" font-family="OpenSans-Regular, Open Sans" font-weight="normal">%</tspan>
                </text>
                </g>
            </g>
            <g class="bar-wrapper" transform="translate(522.000000, 0.000000)">
                <g transform="translate(0.000000, 36.000000)">
                    <rect fill="#EEE8D3" x="0" y="0" width="60" height="400"></rect>
                    <rect fill="#7FC82F" x="0" y="256" width="60" height="144" style="transform-origin: 100% 100%; transform-box: fill-box;"></rect>
                    <rect fill="#417505" x="0" y="296" width="60" height="104" style="transform-origin: 100% 100%; transform-box: fill-box;"></rect>
                </g>
                <text font-family="OpenSans-Semibold, Open Sans" font-size="13" font-weight="500" fill="#000000">
                    <tspan x="3.90161133" y="14">Espagne</tspan>
                </text>
                                <g class="graph-numbers">

                <text font-family="OpenSans-Semibold, Open Sans" font-size="13" font-weight="500" fill="#FFFFFF">
                    <tspan x="17.2285156" y="310">36</tspan>
                    <tspan x="32.0693359" y="310" font-family="OpenSans-Regular, Open Sans" font-weight="normal">%</tspan>
                </text>
                <text font-family="OpenSans-Semibold, Open Sans" font-size="13" font-weight="500" fill="#FFFFFF">
                    <tspan x="17.2285156" y="350">26</tspan>
                    <tspan x="32.0693359" y="350" font-family="OpenSans-Regular, Open Sans" font-weight="normal">%</tspan>
                </text>
                </g>
            </g>
            <g class="bar-wrapper" transform="translate(682.000000, 0.000000)">
                <g transform="translate(0.000000, 36.000000)">
                    <rect fill="#EEE8D3" x="0" y="0" width="60" height="400"></rect>
                    <rect fill="#7FC82F" x="0" y="296" width="60" height="104" style="transform-origin: 100% 100%; transform-box: fill-box;"></rect>
                    <rect fill="#417505" x="0" y="328" width="60" height="72" style="transform-origin: 100% 100%; transform-box: fill-box;"></rect>
                </g>
                <text font-family="OpenSans-Semibold, Open Sans" font-size="13" font-weight="500" fill="#000000">
                    <tspan x="2.94311523" y="14">Mexique</tspan>
                </text>
                                <g class="graph-numbers">

                <text font-family="OpenSans-Semibold, Open Sans" font-size="13" font-weight="500" fill="#FFFFFF">
                    <tspan x="17.2285156" y="350">26</tspan>
                    <tspan x="32.0693359" y="350" font-family="OpenSans-Regular, Open Sans" font-weight="normal">%</tspan>
                </text>
                <text font-family="OpenSans-Semibold, Open Sans" font-size="13" font-weight="500" fill="#FFFFFF">
                    <tspan x="17.2285156" y="382">18</tspan>
                    <tspan x="32.0693359" y="382" font-family="OpenSans-Regular, Open Sans" font-weight="normal">%</tspan>
                </text>
                </g>
            </g>
            <g class="bar-wrapper" transform="translate(772.000000, 0.000000)">
                <g transform="translate(0.000000, 36.000000)">
                    <rect fill="#EEE8D3" x="0" y="0" width="60" height="400"></rect>
                    <rect fill="#7FC82F" x="0" y="312" width="60" height="88" style="transform-origin: 100% 100%; transform-box: fill-box;"></rect>
                    <rect fill="#417505" x="0" y="336" width="60" height="64" style="transform-origin: 100% 100%; transform-box: fill-box;"></rect>
                </g>
                <text font-family="OpenSans-Semibold, Open Sans" font-size="13" font-weight="500" fill="#000000">
                    <tspan x="12.0710449" y="14">Chine</tspan>
                </text>
                                <g class="graph-numbers">

                <text font-family="OpenSans-Semibold, Open Sans" font-size="13" font-weight="500" fill="#FFFFFF">
                    <tspan x="17.2285156" y="365">22</tspan>
                    <tspan x="32.0693359" y="365" font-family="OpenSans-Regular, Open Sans" font-weight="normal">%</tspan>
                </text>
                <text font-family="OpenSans-Semibold, Open Sans" font-size="13" font-weight="500" fill="#FFFFFF">
                    <tspan x="17.2285156" y="390">16</tspan>
                    <tspan x="32.0693359" y="390" font-family="OpenSans-Regular, Open Sans" font-weight="normal">%</tspan>
                </text>
                </g>
            </g>
            <g class="bar-wrapper" transform="translate(862.000000, 0.000000)">
                <g transform="translate(0.000000, 36.000000)">
                    <rect fill="#EEE8D3" x="0" y="0" width="60" height="400"></rect>
                    <rect fill="#7FC82F" x="0" y="336" width="60" height="64" style="transform-origin: 100% 100%; transform-box: fill-box;"></rect>
                    <rect fill="#417505" x="0" y="352" width="60" height="48" style="transform-origin: 100% 100%; transform-box: fill-box;"></rect>
                </g>
                <text font-family="OpenSans-Semibold, Open Sans" font-size="13" font-weight="500" fill="#000000">
                    <tspan x="16.095459" y="14">Inde</tspan>
                </text>
                                <g class="graph-numbers">

                <text font-family="OpenSans-Semibold, Open Sans" font-size="13" font-weight="500" fill="#FFFFFF">
                    <tspan x="17.2285156" y="385">16</tspan>
                    <tspan x="32.0693359" y="385" font-family="OpenSans-Regular, Open Sans" font-weight="normal">%</tspan>
                </text>
                <text font-family="OpenSans-Semibold, Open Sans" font-size="13" font-weight="500" fill="#FFFFFF">
                    <tspan x="17.2285156" y="406">12</tspan>
                    <tspan x="32.0693359" y="406" font-family="OpenSans-Regular, Open Sans" font-weight="normal">%</tspan>
                </text>
                </g>
            </g>
        </g>
    </g>
</svg>`;

    const legend = `
<svg width="150px" height="71px" viewBox="0 0 150 71" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <g transform="translate(0.000000, -3.000000)">
            <text font-family="OpenSans-Regular, Open Sans" font-size="13" font-weight="normal" fill="#000000">
                <tspan x="26" y="14">Maximum théorique</tspan>
            </text>
            <rect fill="#7FC82F" x="0" y="3" width="16" height="16"></rect>
            <text font-family="OpenSans-Regular, Open Sans" font-size="13" font-weight="normal" fill="#000000">
                <tspan x="26" y="52">Potentiel sans perte</tspan>
                <tspan x="26" y="70">de productivité</tspan>
            </text>
            <rect fill="#417505" x="0" y="41" width="16" height="16"></rect>
        </g>
    </g>
</svg>`;
    return (
        <div className={styles.Main} ref={element}>
            <div dangerouslySetInnerHTML={{__html: svg}}/>

            <div dangerouslySetInnerHTML={{__html: legend}}/>
        </div>
    )
}
